/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import type { TablePaginationConfig, TableProps } from 'antd';
import { ICustomerOrderReportRes } from '@/interfaces/report';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import TableComponent from '@/components/table';
import { formatDate, formatNumber } from '@/utils/dataUtils';

interface IProps {
  margin: number;
  loading: boolean;
  report: ICustomerOrderReportRes[];
  onTableChange: (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter:
      | SorterResult<ICustomerOrderReportRes>
      | SorterResult<ICustomerOrderReportRes>[],
  ) => void;
}

const CustomerOrderReportTable = ({
  loading,
  report,
  onTableChange,
}: IProps) => {
  const columns: TableProps<ICustomerOrderReportRes>['columns'] = [
    {
      title: 'BU',
      dataIndex: 'businessUnitName',
      key: 'businessUnitName',
      width: 80,
      align: 'center',
    },
    {
      title: 'IV NUMBER',
      dataIndex: 'ivNo',
      key: 'ivNo',
    },
    {
      title: 'PO NUMBER',
      dataIndex: 'poNo',
      key: 'poNo',
    },
    {
      title: 'PRODUCT',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: 'QUANTITY',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: _ => formatNumber(_),
    },
    {
      title: 'DELIVERY DATE',
      dataIndex: 'orderDate',
      key: 'orderDate',
      align: 'center',
      render: _ => formatDate(_),
    },
    {
      title: 'FEEDMILL',
      dataIndex: 'shippingAddressName',
      key: 'shippingAddressName',
    },
    {
      title: 'ทะเบียนรถ',
      dataIndex: 'numberPlate',
      key: 'numberPlate',
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <TableComponent<ICustomerOrderReportRes>
        columns={columns}
        criteria={undefined}
        data={{ data: report, totalRecords: report.length || 0 }}
        loading={loading}
        onTableChange={onTableChange}
        showPagination={false}
        scrollLength={1600}
      />
    </div>
  );
};

export default CustomerOrderReportTable;
